export default "__VITE_ASSET__$eHLs5PK__"